import { createApp } from 'vue';
import TDesign from 'tdesign-vue-next';
import App from './App.vue'; 
import router from './router'

// 样式导入 - 移除重复导入
import 'tdesign-vue-next/es/style/index.css';
// 引入自定义主题
import './styles/theme.css';

const app = createApp(App);
app.use(TDesign);
app.use(router);
app.mount('#app');